import React from "react";
import { Stack, Typography } from "@mui/material";

import { StyledSubStack } from "./styles";
import LaborTable from "../WorkOrderRoutingTable/LaborTable";

const SubRoutingLabor = ({ item, open }) => {
  const routeId = item?.id;
  return (
    <StyledSubStack gap="25px">
      <Stack gap="10px">
        <Typography variant="boldCaptionL" fontSize={12}>
          Labor
        </Typography>
        <LaborTable routeId={routeId} enabled={open} />
      </Stack>
    </StyledSubStack>
  );
};

export default SubRoutingLabor;
